import { getEnv } from "@/lib/env";
const TELEGRAM_BOT_LINK =
  getEnv.VITE_TELEGRAM_BOT_LINK || "https://t.me/your_bot";

type Props = {
  children: React.ReactNode;
  ref?: string;
};
const TelegramLoginLink = ({ children, ref }: Props) => {
  return (
    <a href={`${TELEGRAM_BOT_LINK}?start=${ref ?? "_"}`} target="_blank">
      {children}
    </a>
  );
};

export default TelegramLoginLink;
